'use client'

import { createContext, type ReactNode, use } from 'react'

export type NetworkWizardNavContextValue = {
  goNext: () => void
  goPrev: () => void
  submitting: boolean
  isFirstStep: boolean
  isLastStep: boolean
}

const NetworkWizardNavContext = createContext<
  NetworkWizardNavContextValue | undefined
>(undefined)

export const NetworkWizardNavProvider = ({
  children,
  value,
}: {
  children: ReactNode
  value: NetworkWizardNavContextValue
}) => (
  <NetworkWizardNavContext.Provider value={value}>
    {children}
  </NetworkWizardNavContext.Provider>
)

export const useNetworkWizardNav = (): NetworkWizardNavContextValue => {
  const ctx = use(NetworkWizardNavContext)
  if (!ctx) {
    throw new Error(
      'useNetworkWizardNav must be used within NetworkWizardNavProvider'
    )
  }
  return ctx
}
